export default "__VITE_ASSET__C4K8danL__"